<template>
  <section
    v-if="value !== null"
    class="data"
  >
    <p class="hd-type-04 mr5">
      <span>{{ title }}</span>
    </p>
    <job-preview-content-data-tooltip-sp />
    <div class="container mt30">
      <div class="graph_inner">
        <div class="graph">
          <div
            class="bar average"
            :style="`height: ${averageHight}px; margin-top: ${graphHight-averageHight}px;`"
          >
            <p><span>{{ averageValue }}</span><span>{{ unit }}</span></p>
          </div>
          <div
            class="bar this"
            :style="`height: ${thisHight}px; margin-top: ${graphHight-thisHight}px;`"
          >
            <p><span>{{ value }}</span><span>{{ unit }}</span></p>
          </div>
        </div>
        <div class="label-horizontal">
          <div class="user-label">
            全国平均
          </div>
          <div class="user-label">
            当社
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import JobPreviewContentDataTooltipSp from '@/components/atoms/JobPreviewContentDataTooltipSp'
import jobPreviewGraph from '@/lib/jobPreviewGraph'

export default {
  components: {
    JobPreviewContentDataTooltipSp
  },
  mixins: [jobPreviewGraph],
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default: null
    },
    averageValue: {
      type: Number,
      default: null
    },
    unit: {
      type: String,
      required: true
    }
  }
}
</script>
